
<div class="pin-reset-container">
  <!-- Steps container valid for Postal Address only -->


  <div class="postal-address hide1"  >
    <div class="postal-step-content hide1" *ngIf="panelValidation()">
      <f-alert variant="info" class="status-msg">Ask the customer to verify the address below. If it’s incorrect, do not
        share the listed address.</f-alert>
      <p class="pin-content">
        The PIN will be sent to: <strong>{{rootScope.pinReminderAddress.get(rootScope.activeCustTab.customerSessionId)}}</strong>
      </p>
    </div>
    <div class="success-msg" *ngIf="rootScope.pinReminderSuccessMsg" >
      <f-alert variant="success" class="status-msg">{{PINREMINDER.PIN_REMINDER_SUCCESS}}</f-alert>
      <p  class="pin-content">The PIN has been sent to: <strong> {{rootScope.pinReminderAddress.get(rootScope.activeCustTab.customerSessionId)}}</strong></p>
      <p class="pin-content hide1">{{PINREMINDER.PIN_REMINDER_SUCCESS_info}}</p>
    </div>
    <div class="failure-msg" *ngIf="errorMsg()" >
      <f-alert variant="error" class="status-msg">{{rootScope.pinReminderErrorMsg}}</f-alert>
    </div>
    <div class="btn-controls">
     
      <f-button text="Send PIN Reminder"  title="Send PIN Reminder" type="button" variant="progressive" class="hide1" *ngIf="panelValidation()" (click)="openModelOverlay()"></f-button>
      <f-button text="Try again" title="Try again"  type="button" variant="progressive" class="hide1" *ngIf="errorMsg('btn')" (click)="resetPinReminder()"></f-button>
    </div>

  </div>

</div>

<!-- Pin Reminder confirmation request full view popup here -->
<div class="custom-overlay-container pin-reminder " *ngIf="rootScope.showPinReminderConfirmationOverlay">
  <div class="custom-overlay-body">
    <div class="custom-overlay-content" role="dialog">
      <!-- <div class="overlay-header">
    <h5>Confirm PIN Reminder Request</h5>
  </div>
  <div class="section-divider"></div> -->

      <div class="overlay-body">
        <strong>Read PIN Reminder Script prior to processing </strong>
        <div class="pin-reminder-script">
          <p>"Before I send a PIN reminder request, I need you to acknowledge that doing this will reset your <f-button
              text="MyFRS.com" variant="ghost" (click)="rootScope.openNewTab(rootScope.myFRSLink)"></f-button> profile if you have previously created one. By sending this
            PIN request, you will be required to go through the authentication process to register a new profile. Until
            you have done so, you will not be able to access <f-button text="MyFRS.com" variant="ghost" (click)="rootScope.openNewTab(rootScope.myFRSLink)"></f-button>.
            Acknowledging this, would you like me to send your PIN request?"</p>
          <p>If <strong> Yes</strong>, "At this time I will send out the PIN reminder which has reset your <f-button
              text="MyFRS.com" variant="ghost" (click)="rootScope.openNewTab(rootScope.myFRSLink)"></f-button>
            account. The reminder will be placed in the mail within 2 business days. Please allow for normal mailing
            time."</p>
          <p>If <strong> No</strong>, "At this time I will not send a PIN reminder to your mailing address on file."</p>
        </div>
      </div>

      <div class="button-controls">
        <f-button text="No" title="Close" type="button" variant="action" (click)="closeModelOverlay('No')">
        </f-button>
        <f-button text="Yes" title="Submit" type="button" variant="progressive"
          (click)="closeModelOverlay('Yes')"></f-button>
      </div>
    </div>
  </div>
</div>